import { EventBySlugOutput } from "~/types/EventTypesInferred";
import { api } from "~/utils/api";

const useIsRegistered = (event: EventBySlugOutput) => {
    const { data: isRegistered, isLoading: isRegisteredLoading } =
        api.event.isRegistered.useQuery(event?.id, {
            enabled: !!event?.id,
        });

    return { isRegistered, isRegisteredLoading };
};

export default useIsRegistered;
